import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid } from 'src/components';
import BaseComponent from 'src/core/base.component';
import { translate } from 'src/i18n/tHelper';
import KurumBonusTanimlariTestVeVeriyeGoreListe from './Liste';
import KurumBonusTanimlariTestVeVeriyeGoreListeEkle from './Ekle';
import { useAppSelector } from 'src/store';

const translatePath = "pages|kurumBonusTanimlari";
const KurumBonusTanimlariTestVeVeriyeGore = (): JSX.Element => {
    const state = useAppSelector(s => s.kurumBonusTanimlariTestVeVeriyeGore);
    return (
        <>
            <Helmet><title>{translate(translatePath, "Kurum Bonus Tanımları Test ve Veriye Göre")}</title></Helmet>
            <BaseComponent>
                <Grid container>
                    <Grid item>
                        <KurumBonusTanimlariTestVeVeriyeGoreListe />
                    </Grid>
                </Grid>
            </BaseComponent>
            {state.open && <KurumBonusTanimlariTestVeVeriyeGoreListeEkle />}
        </>
    );
};

export default KurumBonusTanimlariTestVeVeriyeGore;